const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Micro Alphabet Stamps
  {
    path: '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet',
    name: 'micro-alphabet-stamps',
    component: ProductList,
    props: {
      title: 'Sets de micro tampons alphabet',
      description:
        "Le set de micro tampons est un incontournable pour tes compostions typographiques.<br/> Chaque set comprend 134 caractères. 82 majuscules, 46 chiffres et quelques symboles de ponctuation, pour un usage ultra polyvalent.<br/> N’hésite pas à associer les micro tampons avec un set de tampons alphabet plus grand pour des possibilités infinies.",
      tags: ['set-micro-tampon-alphabet'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/micro-tampons/dosis-vignette.jpg'),
          name: 'Set de micro tampons alphabet',
          variant: 'Dosis',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet/set-complet-dosis-micro',
        },
        {
          src: require('../../../public/img/materiel-creatif/micro-tampons/choco-shake-vignette.jpg'),
          name: 'Set de micro tampons alphabet',
          variant: 'Choco Shake',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet/set-complet-choco-shake-micro',
        },
        {
          src: require('../../../public/img/materiel-creatif/micro-tampons/alba-vignette.jpg'),
          name: 'Set de micro tampons alphabet',
          variant: 'Alba',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet/set-complet-alba-micro',
        },
      ],
    },
  },

  // Micro Dosis
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet/set-complet-dosis-micro',
    name: 'full-micro-set-dosis',
    component: () => import('../../pages/products/creative/micro/Dosis/DosisMicro'),
    props: {
      src: require('../../../public/img/materiel-creatif/micro-tampons/dosis-vignette.jpg'),
      type: 'Set complet Dosis micro',
      hiddenType: 'full-micro-set-dosis',
      description:
        "Les micro tampons mesurent seulement 5mm de haut, ils sont très lisibles et parfaits pour les petits textes de plusieurs lignes. <br/>Chaque set comprend 134 caractères. 82 majuscules, 46 chiffres et quelques symboles de ponctuation. <br/> Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br/> Utilise la réglette d'alignement double pour un tamponnage droit et rapide, ou alors les pinces à lettre pour un tamponnage facile et créatif. <br/> Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-complet-dosis-micro'],
    },
  },

  // Micro Choco Shake
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet/set-complet-choco-shake-micro',
    name: 'full-micro-set-choco-shake',
    component: () => import('../../pages/products/creative/micro/ChocoShake/ChocoShakeMicro'),
    props: {
      src: require('../../../public/img/materiel-creatif/micro-tampons/choco-shake-vignette.jpg'),
      type: 'Set complet Choco Shake micro',
      hiddenType: 'full-micro-set-choco-shake',
      description:
        "Les micro tampons mesurent seulement 5mm de haut, ils sont très lisibles et parfaits pour les petits textes de plusieurs lignes. <br/>Chaque set comprend 134 caractères. 82 majuscules, 46 chiffres et quelques symboles de ponctuation. <br/> Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br/> Utilise la réglette d'alignement double pour un tamponnage droit et rapide, ou alors les pinces à lettre pour un tamponnage facile et créatif. <br/> Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-complet-choco-shake-micro'],
    },
  },

  // Micro Alba
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet/set-complet-alba-micro',
    name: 'full-micro-set-alba',
    component: () => import('../../pages/products/creative/micro/Alba/AlbaMicro'),
    props: {
      src: require('../../../public/img/materiel-creatif/micro-tampons/alba-vignette.jpg'),
      type: 'Set complet Alba micro',
      hiddenType: 'full-micro-set-alba',
      description:
        "Les micro tampons mesurent seulement 5mm de haut, ils sont très lisibles et parfaits pour les petits textes de plusieurs lignes. <br/>Chaque set comprend 134 caractères. 82 majuscules, 46 chiffres et quelques symboles de ponctuation. <br/> Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br/> Utilise la réglette d'alignement double pour un tamponnage droit et rapide, ou alors les pinces à lettre pour un tamponnage facile et créatif. <br/> Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-complet-alba-micro'],
    },
  },
];
